import React, { useEffect } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
// Data
import { layoutUpdate, loadPage } from 'src/actions/common';
import { ACCOUNT_ORDERS_PAGE_LAYOUT } from './constants';
import { immutableToJS } from 'src/utils/helpers';
import { userSelector } from 'src/selectors/user';
import pageSelector from 'src/selectors/page';
import { ordersListStateSelector } from 'src/selectors/order';

// Components
import withToggleSiteNav from 'src/hoc/withToggleSiteNav';
import { Grid } from 'src/components/HTKit/Grid';
import PageLoader from 'src/components/PageLoader';
import Notice from 'src/components/Notice';
import SuspendedAutoPayNotification from 'src/components/SuspendedAutoPayNotification';
import AccountNavigation from '../Parts/AccountNavigation';
import { OrdersList } from './AccountOrdersPage.OrdersList';
// Styles
import styles from './styles.scss';

const AccountOrdersPage = ({ toggleSiteNav }) => {
  const dispatch = useDispatch();

  const location = useLocation();

  useEffect(() => {
    dispatch(layoutUpdate(ACCOUNT_ORDERS_PAGE_LAYOUT));
    dispatch(loadPage('accountOrders'));
  }, []);

  const { pathname } = location;
  const user = useSelector(userSelector);
  const page = useSelector(pageSelector('accountOrders'));
  const ordersList = useSelector(ordersListStateSelector);

  const orders = ordersList ? immutableToJS(ordersList) : null;

  if (page.get('loading') || !user) return <PageLoader />;

  const plan = user.getIn(['account', 'plan']);
  const autoPayIsSuspended = plan && plan.get('isSuspended') && plan.get('autoRenew');

  return (
    <>
      <Helmet title="My Orders" />
      <AccountNavigation currentRoute={pathname} user={user} />
      <Grid.Fluid classes={cn(styles.pageContent, 'site-v2')}>
        <SuspendedAutoPayNotification isSuspended={autoPayIsSuspended} />
        <Notice page="accountOrders" className={styles.notice} />
        <OrdersList orders={orders} toggleSiteNav={toggleSiteNav} />
      </Grid.Fluid>
    </>
  );
};

AccountOrdersPage.propTypes = { toggleSiteNav: PropTypes.func.isRequired };

export default withToggleSiteNav()(AccountOrdersPage);
